import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=abf569c0&scoped=true&"
import script from "./data-list.vue?vue&type=script&lang=js&"
export * from "./data-list.vue?vue&type=script&lang=js&"
import style0 from "./data-list.vue?vue&type=style&index=0&id=abf569c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf569c0",
  null
  
)

export default component.exports